import './pegasus_template/precompiled-templates.js'
import './pegasus_template/app.js'
import './pegasus_template/helpers.js'
import './pegasus_template/drag_manager.js'
import './pegasus_template/states.js'
import './pegasus_template/store.js'
import './pegasus_template/routes.js'
import './pegasus_template/models.js'
import './pegasus_template/computed.js'
import './pegasus_template/io_manager.js'
import './pegasus_template/command_manager.js'
import './pegasus_template/commands.js'
import './pegasus_template/controllers.js'

import './pegasus_template/views.js'
import './pegasus_template/images.js'
import '~/pegasus_template/components/loading_spinner/component.js'

require('./pegasus_template/assets/stylesheets/editor.css.scss');

export default window.PegasusTemplate;
